"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNewCropForResizedUserPhotoLayer = exports.compareByReadingOrder = exports.userPhotoLayerHasMaxCrop = exports.updatePrintableDesignLayers = exports.shiftDesignLayersRight = exports.makeCompositeDesign = exports.getCropForUserPhotoLayer = exports.getCropForUserPhotoLayerInPrintableInProject = exports.SpreadSide = exports.CoverageType = exports.getCoverageType = void 0;
var getCoverageType_1 = require("./getCoverageType");
Object.defineProperty(exports, "getCoverageType", {
  enumerable: true,
  get: function () {
    return __importDefault(getCoverageType_1).default;
  }
});
Object.defineProperty(exports, "CoverageType", {
  enumerable: true,
  get: function () {
    return getCoverageType_1.CoverageType;
  }
});
Object.defineProperty(exports, "SpreadSide", {
  enumerable: true,
  get: function () {
    return getCoverageType_1.SpreadSide;
  }
});
var getCropForUserPhotoLayerInPrintableInProject_1 = require("./getCropForUserPhotoLayerInPrintableInProject");
Object.defineProperty(exports, "getCropForUserPhotoLayerInPrintableInProject", {
  enumerable: true,
  get: function () {
    return __importDefault(getCropForUserPhotoLayerInPrintableInProject_1).default;
  }
});
var getCropForUserPhotoLayer_1 = require("./getCropForUserPhotoLayer");
Object.defineProperty(exports, "getCropForUserPhotoLayer", {
  enumerable: true,
  get: function () {
    return __importDefault(getCropForUserPhotoLayer_1).default;
  }
});
var makeCompositeDesign_1 = require("./makeCompositeDesign");
Object.defineProperty(exports, "makeCompositeDesign", {
  enumerable: true,
  get: function () {
    return __importDefault(makeCompositeDesign_1).default;
  }
});
var shiftDesignLayersRight_1 = require("./shiftDesignLayersRight");
Object.defineProperty(exports, "shiftDesignLayersRight", {
  enumerable: true,
  get: function () {
    return __importDefault(shiftDesignLayersRight_1).default;
  }
});
var updatePrintableDesignLayers_1 = require("./updatePrintableDesignLayers");
Object.defineProperty(exports, "updatePrintableDesignLayers", {
  enumerable: true,
  get: function () {
    return updatePrintableDesignLayers_1.updatePrintableDesignLayers;
  }
});
var userPhotoLayerHasMaxCrop_1 = require("./userPhotoLayerHasMaxCrop");
Object.defineProperty(exports, "userPhotoLayerHasMaxCrop", {
  enumerable: true,
  get: function () {
    return __importDefault(userPhotoLayerHasMaxCrop_1).default;
  }
});
var compareByReadingOrder_1 = require("./compareByReadingOrder");
Object.defineProperty(exports, "compareByReadingOrder", {
  enumerable: true,
  get: function () {
    return __importDefault(compareByReadingOrder_1).default;
  }
});
var getNewCropForResizedUserPhotoLayer_1 = require("./getNewCropForResizedUserPhotoLayer");
Object.defineProperty(exports, "getNewCropForResizedUserPhotoLayer", {
  enumerable: true,
  get: function () {
    return getNewCropForResizedUserPhotoLayer_1.getNewCropForResizedUserPhotoLayer;
  }
});